"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBannersServiceProxyUrl = exports.REPORT_EVENT_URL = exports.OFFERS_SERVING = void 0;
exports.OFFERS_SERVING = '/_api/dealer-offers-serving-service/v1/dealer/serving/offers';
exports.REPORT_EVENT_URL = function (offerId) {
    return "/_api/dealer-offer-events-service/v1/dealer-offer-events/" + offerId;
};
exports.getBannersServiceProxyUrl = function (domain) {
    return "/_serverless/dealer-banners-service-proxy/" + domain;
};
//# sourceMappingURL=services-url.js.map